import React from 'react';

export function haltClickEventPropagation(event: React.MouseEvent | MouseEvent | undefined): void {
	event?.stopPropagation();
}

export function haltKeyboardEventPropagation(event: React.KeyboardEvent | undefined): void {
	event?.stopPropagation();
}

export function haltEvent(event: React.MouseEvent | React.KeyboardEvent | MouseEvent | undefined): void {
	event?.preventDefault();
	event?.stopPropagation();
}

export function ifClickHandler<T>(
	clickHandler?: (arg?: T) => void,
	arg?: T
): ((event?: React.MouseEvent) => void) | undefined {
	if (clickHandler) {
		return (event?: React.MouseEvent) => {
			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}

			clickHandler(arg);
		};
	}

	return undefined;
}

export function on(eventType: string, listener: EventListener): void {
	document.addEventListener(eventType, listener);
}

export function off(eventType: string, listener: EventListener): void {
	document.removeEventListener(eventType, listener);
}

export function once(eventType: string, listener: EventListener): void {
	function handleEventOnce(event: Event) {
		listener(event);
		off(eventType, handleEventOnce);
	}

	on(eventType, handleEventOnce);
}

export function trigger(eventType: string, data?: unknown): void {
	const event = new CustomEvent(eventType, { detail: data });
	document.dispatchEvent(event);
}

export function handleEnter(handler: () => void): React.KeyboardEventHandler<HTMLElement> {
	return function(e: React.KeyboardEvent<HTMLElement>): void {
		if (e.code === 'Enter') {
			handler();
		}
	};
}

export function handleEscape(handler: () => void): EventListener {
	return function(e: KeyboardEvent): void {
		if (e.code === 'Escape') {
			handler();
		}
	};
}
